import React from "react";
import ReactDom from "react-dom";
import AzureB2CUploadCsvForm from "./AzureB2CUploadCsvForm.jsx";
export const initAzureB2CUploadCsvForm = () => {
  document
    .querySelectorAll(".js-azureb2cuploadcsv")
    .forEach(containerElement => {
      ReactDom.render(<AzureB2CUploadCsvForm />, containerElement);
    });
};
